// Aggregates every product's own content/articles/<product>/index.js registry
// into one lookup, so ArticlePage and RelatedArticles can resolve any slug or
// category without knowing which product folder it lives in. Adding a new
// product's articles later means adding one import + one entry to
// PRODUCT_REGISTRIES below — nothing else in this file changes shape.
import * as szemelyiKolcson from "./szemelyi-kolcson";

const PRODUCT_REGISTRIES = [szemelyiKolcson];

export const ARTICLES_META = PRODUCT_REGISTRIES.flatMap(
  (registry) => registry.ARTICLES_META
);

export const ARTICLE_CONTENT_LOADERS = Object.assign(
  {},
  ...PRODUCT_REGISTRIES.map((registry) => registry.ARTICLE_CONTENT_LOADERS)
);

const ARTICLE_IMPORTERS = Object.assign(
  {},
  ...PRODUCT_REGISTRIES.map((registry) => registry.ARTICLE_IMPORTERS)
);

// The ArticlePage route chunk itself — App.js lazy-loads it through this same
// function, so a prefetch here and the route's own load share one request.
export const loadArticlePage = () => import("../../landings/ArticlePage");

/**
 * Warms the webpack chunk cache for an article: both the ArticlePage route
 * chunk and that article's body chunk. Without this, clicking a related
 * article waits on two chunk downloads back to back (route, then body) before
 * any content shows. Safe to call repeatedly — import() resolves from cache.
 *
 * @param {string} slug
 */
export function preloadArticle(slug) {
  const swallow = () => {};
  loadArticlePage().catch(swallow);
  ARTICLE_IMPORTERS[slug]?.().catch(swallow);
}

/**
 * @param {string} slug
 * @returns {object|null}
 */
export function getArticleMeta(slug) {
  return ARTICLES_META.find((article) => article.slug === slug) || null;
}

/**
 * @param {string} category
 * @param {string} excludeSlug
 * @param {number} [limit]
 * @returns {object[]}
 */
export function getRelatedArticlesMeta(category, excludeSlug, limit = 4) {
  return ARTICLES_META.filter(
    (article) => article.category === category && article.slug !== excludeSlug
  )
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}
